import Model, { ID, IsoDateTime, MODEL_LEVEL } from 'src/models/model'
import OrderItem from 'src/models/order-item/OrderItem'
import TipPoolTip from 'src/models/tip/TipPoolTip'
import TipShare from 'src/models/tip/TipShare'
import User from 'src/models/user/User'

export default class Tip extends Model {
  static name = 'Tip'

  static level = MODEL_LEVEL.SITE

  static paginate = true
  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Tipping]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      employee: {
        type: User,
        default: null,
        output: true
      },
      orderItem: {
        type: OrderItem,
        default: null,
        output: true
      },
      tipShare: {
        type: TipShare,
        default: null,
        output: true
      },
      tipPoolTip: {
        type: TipPoolTip,
        default: null,
        output: true
      },
      state: {
        type: String,
        default: null,
        output: true
      },
      amount: {
        type: Number,
        default: 0,
        output: true
      },
      paymentType: {
        type: String,
        default: null,
        output: true
      },
      paidAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      voidedAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      assignedAt: {
        type: IsoDateTime,
        default: null,
        output: true
      }
    }

    this.computed = {
      source () {
        if (_.isNil(this.tipPoolTip)) {
          return 'direct'
        } else if (_.isNil(this.tipPoolTip?.tipPoolType)) {
          return 'pool'
        } else {
          const poolName = this.tipPoolTip?.tipPoolType?.name
          return poolName?.endsWith(' Pool') ? poolName : `${poolName} Pool`
        }
      }
    }
  }
}
